module.exports = __webpack_public_path__ + "static/media/room.cbf07b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/backgrounds/room.png
// module id = 242
// module chunks = 0